<template>
  <transition name="fade">
    <div class="row justify-content-center">
      <!-- <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" /> -->

      <div class="col-lg-10 col-md-12 col-sm-12">
        <transition name="fade">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title bold">
                Kindly follow our guide questions to apply a loan
              </h3>
            </div>
            <div class="card-body">
              <p class="card-text text-justify">
                Are you a Filipino Citizen owning or representing a
                majority-owned Filipino business?
              </p>
              <div class="row">
                <div class="col-6 text-center">
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="y1" value="Y" v-model="formLoan.filipino" />
                    <label for="y1" :class="{errorRadio: submitting && $v.formLoan.filipino.$error,}">Yes</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="n1" value="N" v-model="formLoan.filipino" />
                    <label for="n1" :class="{errorRadio: submitting && $v.formLoan.filipino.$error}">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn btn-primary" @click="deleteLoanApp">
                <i class="fas fa-arrow-left mr-1"></i>Back
              </button>
              <button class="btn btn-primary float-right" @click="next">
                Next<i class="fas fa-arrow-right ml-1"></i>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>
<script>
  import {
    required,
    minLength
  } from "vuelidate/lib/validators";
  // api
  import {
    apiUpdateLoanReq
  } from "@js/api/applyLoanApi";


  export default {
    props: ['formLoan'],
    data() {
      return {
        submitting: false,
        loader: 0,


        error: 0,
        error_message: '',
        errors: []
      };
    },

    validations: {
      formLoan: {
        filipino: {
          required,
        },
      },
    },
    created() {},
    methods: {

      deleteLoanApp() {
        this.$emit('load', 1);
        axios.post('/api/v2-del-loan-app', {
            application_id: this.formLoan.application_id,
          })
          .then(res => {
            this.$emit('load', -1);
            this.$router.push('/apply-loan');
          }).catch(err => {
            this.$emit('load', -1);
          })
      },

      async apiSubmit() {
        this.$emit('load', 1);
        const form = {
          application_id: this.formLoan.application_id,
          filipino: this.formLoan.filipino,
        }
        try {
          const res = await apiUpdateLoanReq(form);
          this.$emit('next');
        } catch (error) {
          this.$emit('error', error);
        } finally {
          this.$emit('load', -1);
        }
      },

      next() {
        this.submitting = true;
        this.$v.formLoan.$touch();
        if (this.$v.formLoan.$invalid) {
          const err = {
            response: {
              data: {
                message: "Please complete all required fields",
              }
            }
          };
          this.$emit('error', err);
        } else {
          if (this.formLoan.filipino == "Y") {
            this.apiSubmit();
          } else {
            this.$swalDQ();
          }
        }
      },
    },
    computed: {
      processingAPI() {
        return this.loader > 0;
      },
    },
    mounted() {},
  };
</script>